<template>
  <md-layout md-column-medium>
    <md-layout md-flex="33">
      <div class="cont md-card md-table-card md-theme-default">
        <md-toolbar>
          <translate class="md-title">Selected products</translate>
        </md-toolbar>
        <md-table v-if="products.length > 0">
          <md-table-header>
            <md-table-row>
              <md-table-head><translate>Product</translate></md-table-head>
              <md-table-head v-if="order"><translate>Quantity</translate></md-table-head>
              <md-table-head><translate>Price (incl. VAT)</translate></md-table-head>
              <md-table-head><translate translate-comment="Table heading in order selector">Remove</translate></md-table-head>
            </md-table-row>
          </md-table-header>
          <md-table-body>

            <md-table-row v-for="(product, index) in products" :key="index">

              <md-table-cell v-if="product.custom" class="column">
              <md-input-container class="input-price">
                <md-input v-model="product.name"></md-input>
              </md-input-container>
              </md-table-cell>
              <md-table-cell v-else class="column">{{ productName(product) }}</md-table-cell>

              <md-table-cell v-if="order" class="column2">
                <md-input-container class="input-quantity">
                  <md-input v-model.number="product.quantity" type="number" min="0" max="9999"></md-input>
                </md-input-container>
              </md-table-cell>

              <md-table-cell class="column md-body-2" v-if="order"><span v-if="!product.custom">{{ (product.quantity * product.price).toFixed(2) }}€</span></md-table-cell>

              <md-table-cell v-else class="column">
                <md-input-container class="input-price">
                  <!-- <md-input v-model.number="product.price" type="number" min="0" max="9999" step="0.01" placeholder="0.00"></md-input> -->
                  <currency-input
                    :price="product.price"
                    @priceChanged="(value) => {product.price = value}"
                  ></currency-input>
                  <md-icon>euro_symbol</md-icon>
                </md-input-container>
              </md-table-cell>
              <md-table-cell class="cell-icon-container">
                <md-button :id="'product-remove-' + index" @click.native="productRemove(product)" class="md-icon-button">
                  <md-icon class="cell-icon">delete</md-icon>
                </md-button>
              </md-table-cell>

            </md-table-row>
          </md-table-body>
        </md-table>
        <div v-else class="empty-div">
          <translate v-if="order">Shopping cart is empty</translate>
          <translate v-else>No products on the list</translate>
        </div>
      </div>
    </md-layout>

    <md-layout>
      <div class="cont md-card md-table-card md-theme-default">
        <md-toolbar>
          <translate class="md-title">All available products</translate>
        </md-toolbar>
        <md-card-area v-if="prodAvailable.length > 0" class="card-set">
          <md-card class="card" v-for="(product, index) in prodAvailable" :key="product._id">
            <a :id="'product-clicked-' + index" @click="productClicked(product, $event)" href="#">
              <md-card-area md-inset :class="{'card-highlight': doesContain(product)}">
                <md-card-header>
                  <div v-if="product.custom" class="md-subheading prod-name"><translate>Add custom product</translate></div>
                  <div v-else class="md-subheading prod-name">{{ product.name }}</div>
                </md-card-header>
                <md-card-content>
                  <div v-if="product.description !== ''" class="prod-dsc md-body-1"> {{ product.description }} </div>
                  <div v-else class="prod-dsc-empty md-body-1"><translate>No description</translate></div>
                </md-card-content>
              </md-card-area>
            </a>
          </md-card>
        </md-card-area>
        <div v-else class="empty-div">
          <translate>No products available</translate>
          <md-icon class="empty-msg-icon" v-if="errorMsg !== ''">info<md-tooltip md-direction="right">{{ errorMsg }}</md-tooltip></md-icon>
        </div>
      </div>
    </md-layout>
  </md-layout>
</template>

<script>
import CurrencyInput from './CurrencyInput'

export default {
  name: 'product-selector',
  props: [ 'products', 'prodAvailable', 'order', 'errorMsg' ],
  methods: {
    productRemove (product) {
      this.$emit('removeItem', product)
    },
    productName (product) {
      if (product.name !== undefined && product.name !== '') {
        return product.name
      }
      // if (this.prodAvailable.length !== 0) {
      let productFound = this.prodAvailable.find((prod) => {
        return prod._id === product.id
      })
      return productFound.name
      // }
    },
    doesContain (product) {
      return this.products.some((prod) => {
        return prod.id === product._id
      })
    },
    productClicked (product, event) {
      event.preventDefault()
      if (!this.doesContain(product) || product.custom) {
        this.$emit('addItem', {
          'id': product._id || String(new Date().getTime()),
          'name': product.name,
          'custom': product.custom || false,
          'quantity': 1,
          'price': product.price || 0
        })
      }
    },
    inputBlur () {
      console.log('blur')
    },
    inputChange () {
      console.log('change')
    },
    inputFocus (val) {
      console.log('focus', val)
      this.product.price = this.product.price.toFixed(2)
    }
  },
  components: {
    CurrencyInput
  }
}
</script>

<style scoped>
.cont {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 15px;
  text-align: left;
}
.empty-div {
  width: 100%;
  height: 100%;
  padding-left: 24px;
  font-style: italic;
}
.empty-msg-icon {
  color: rgba(10, 81, 181, .35);
}

.column {
  font-size: 1.1em;
}
.input-price, .input-quantity {
  margin-top: 0px;
  padding-top: 0px;
  margin-bottom: 0px;
  min-height: 30px;
}

.card-set {
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  height: 100%
}
.card {
  width: 200px;
  display: inline-block;
  vertical-align: top;
  margin: 5px;
  text-align: center;
}
.card a {
  color: rgba(0, 0, 0, .87) !important;
}
.card a:hover {
  text-decoration: none;
}
.card-highlight {
  background-color: rgba(10, 81, 181, .15)
}
.card:hover {
  background-color: rgba(0, 0, 0, .05)
}
.prod-name,
.prod-dsc {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.prod-dsc-empty {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Selector.vue